import { MessagesSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Greeting block for a brand-new Discussion Room conversation (no messages yet):
 * a chat icon, a personalized greeting, a prompt, and a one-line hint naming the
 * startup. The composer and quick-action chips are rendered below it by the
 * conversation layout.
 */
export function DiscussionWelcome({
  name,
  startupName,
}: {
  name?: string | null;
  startupName?: string | null;
}): JSX.Element {
  const { t } = useTranslation();
  const firstName = (name ?? '').trim().split(/\s+/)[0];
  const startup = (startupName ?? '').trim() || t('discussions.welcome.fallbackStartup');

  return (
    <div
      className="flex max-w-md flex-col items-center gap-4 px-6 text-center"
      data-testid="discussion-welcome"
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 dark:bg-primary-500/15 dark:text-primary-300">
        <MessagesSquare className="h-7 w-7" strokeWidth={2} />
      </span>
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          {firstName
            ? t('discussions.welcome.greetingName', { name: firstName })
            : t('discussions.welcome.greeting')}
        </h2>
        <p className="text-lg text-gray-500 dark:text-gray-400">
          {t('discussions.welcome.subtitle')}
        </p>
        <p className="text-sm text-gray-400 dark:text-gray-500">
          {t('discussions.welcome.hint', { startup })}
        </p>
      </div>
    </div>
  );
}

export default DiscussionWelcome;
